import _taggedTemplateLiteral from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  left: -999em;\n\n  &:focus {\n    left: 0;\n    z-index: ", ";\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  left: 10px;\n  position: absolute;\n  top: 10px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React, { Fragment } from 'react';
import styled from 'styled-components';
import { zIndex } from '@scp/ui-shared/theme/variables';
import { Button } from './Button';
var SkipWrapper = styled.div(_templateObject());
var Skip = styled(Button)(_templateObject2(), zIndex.accessibility);
/**
 * @example ./__docs__/SkipLink.md
 */

export var SkipLink = function SkipLink(_ref) {
  var skipToId = _ref.skipToId,
      title = _ref.title,
      _ref$absolute = _ref.absolute,
      absolute = _ref$absolute === void 0 ? false : _ref$absolute;
  var skipToLink = "#".concat(skipToId);
  var WrappingComponent = absolute ? SkipWrapper : Fragment;
  return React.createElement(WrappingComponent, null, React.createElement(Skip, {
    href: skipToLink
  }, title));
};